module.exports = __webpack_public_path__ + "static/img/jiang4.97e523f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jiang4.png
// module id = dNK3
// module chunks = 1